/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  PostUserRequestsIdSubmitMutationResponse,
  PostUserRequestsIdSubmitPathParams,
  PostUserRequestsIdSubmit400,
} from '../entities/PostUserRequestsIdSubmit'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getPostUserRequestsIdSubmitUrl(id: PostUserRequestsIdSubmitPathParams['id']) {
  return `/user-requests/${id}/submit` as const
}

/**
 * @description Отправка заявки водителя таксопарка
 * @summary Отправка заявки водителя таксопарка
 * {@link /user-requests/:id/submit}
 */
export async function postUserRequestsIdSubmit(id: PostUserRequestsIdSubmitPathParams['id'], config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<PostUserRequestsIdSubmitMutationResponse, ResponseErrorConfig<PostUserRequestsIdSubmit400>, unknown>({
    method: 'POST',
    url: getPostUserRequestsIdSubmitUrl(id).toString(),
    ...requestConfig,
  })
  return res.data
}